import $ from 'jquery'

/**
 * Provides functionality for the archive pages dropdown toggling in mobile.
 * Removes the event listeners if in tablet / desktop mode.
 * @Author Amal Ajith
 */
$(document).ready(() => {

    const slideListNode = document.querySelector('.filters-selects-list');
    const filterLabelNode = document.querySelector('.filters-selects-label');
    const slideListChildren = document.querySelector('.filters-selects-list .filters-selects-box');

    var slideListNodeChildLength = $('.filters-selects-list').find('.filters-selects-box:visible').length;
    // var autoHeight = $('.filters-selects-list .filters-selects-box').height() * slideListNodeChildLength;
    var autoHeight;

    const closeDropdown = () => {
        if(slideListNode && filterLabelNode) {
            $(filterLabelNode).removeClass('opened');
            $(filterLabelNode).attr('aria-pressed',false);
            $(filterLabelNode).attr('aria-expanded',false);
            //$(slideListNode).slideUp();
            $(slideListNode).css({'height':'0', 'overflow':'hidden'});
            $('.filters-selects-list .filters-multiselect-dropdown').attr('tabindex','-1');
            $('.filters-selects-list .react-select__value-container input').attr('tabindex','-1');
        }
    }

    const openDropdown = () => {
        if(slideListNode && filterLabelNode) {
            $(filterLabelNode).addClass('opened');
            $(filterLabelNode).attr('aria-pressed',true);
            $(filterLabelNode).attr('aria-expanded',true);
            //$(slideListNode).slideDown();
            $(slideListNode).css('height',autoHeight);
            $('.filters-selects-list .filters-multiselect-dropdown').attr('tabindex','0');
            $('.filters-selects-list .react-select__value-container input').attr('tabindex','0');
            setTimeout(() => {
                $(slideListNode).css('overflow','initial');
            }, 500);
        }
    }

    const toggleFilterContent = (e) => {
        if(e.type === 'click' || e.code === 'Enter' || e.keyCode === 13) {
            if ($(e.target).hasClass('opened') || $(e.target).parent('.filters-selects-label').hasClass('opened') || $(e.target).parent('.filters-selects-label.filter-jobs-label').hasClass('opened')) {
                closeDropdown();
            } else {
                openDropdown();
            }
        }
    }

    const activateFilterButton = () => {
        if(slideListNode && filterLabelNode) {
            filterLabelNode.addEventListener('click', toggleFilterContent);
            filterLabelNode.addEventListener('keydown', toggleFilterContent);
        }
    }

    const deactivateFilterButton = () => {
        if(slideListNode && filterLabelNode) {
            filterLabelNode.removeEventListener('click', toggleFilterContent);
            filterLabelNode.removeEventListener('keydown', toggleFilterContent);
        }
    }

    let previousWidth = 0;

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            const cr = entry.contentRect;
            autoHeight = slideListNodeChildLength * $(slideListChildren).outerHeight(true);
            // resize observer fires for document height change so comparing with previousWidth.
            if(cr.width < 768 && cr.width !== previousWidth) {
                previousWidth = cr.width;
                activateFilterButton();
                closeDropdown();
                $(filterLabelNode).attr('tabindex','0');
            } else if(cr.width >= 768) {
                deactivateFilterButton();
                openDropdown();
                $(slideListNode).css('height','auto');
                $(filterLabelNode).attr('tabindex','-1');
            } else {
                activateFilterButton();
            }
        }
    });

    resizeObserver.observe(document.body);
    // resizeObserver.observe(filterLabelNode);
})
